import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d52048d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-card ss-fadein" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ss-div-icone-etapa" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "ss-icone-etapa",
    img: "",
    src: "/static/img/configuracao-inicial/icone-produtos.png"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "ant-col ss-div-conteudo"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-card" }, "Decida como vamos organizar seus produtos", -1))
const _hoisted_6 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Tipos de Custo que vou usar", -1))
const _hoisted_8 = { class: "ant-col ss-div-multi-selecao" }
const _hoisted_9 = { class: "ant-col ss-div-outros" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Criar outros", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "ant-divider ant-divider-horizontal ss-div-separador",
  role: "separator"
}
const _hoisted_13 = {
  key: 2,
  class: "ant-row"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Tipos de Preço que vou usar", -1))
const _hoisted_15 = { class: "ant-col ss-div-multi-selecao" }
const _hoisted_16 = { class: "ant-col ss-div-outros" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Criar outros", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 3,
  class: "ant-divider ant-divider-horizontal ss-div-separador",
  role: "separator"
}
const _hoisted_20 = {
  key: 4,
  class: "ant-row"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Unidades que vou usar", -1))
const _hoisted_22 = { class: "ant-col ss-div-multi-selecao" }
const _hoisted_23 = {
  key: 5,
  class: "ant-divider ant-divider-horizontal ss-div-separador",
  role: "separator"
}
const _hoisted_24 = {
  key: 6,
  class: "ant-row ss-div-switch"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Vou usar apenas um estoque", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Criar meus estoques", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 7,
  class: "ant-row ss-div-switch"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Vou usar a tabela de preços padrão", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Criar minhas tabelas de preços", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 8,
  class: "ant-row ss-div-switch"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Vou usar a marca padrão", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Criar minha marca", -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 9,
  class: "ant-row ss-div-switch"
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Vou usar a categoria padrão", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Criar minha categoria", -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 1,
  class: "ant-col ss-div-conteudo"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-card" }, "Decida como vamos organizar seus produtos", -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "ant-col ss-div-icone-etapa" }
const _hoisted_52 = {
  key: 0,
  class: "ss-icone-etapa ss-fadein",
  img: "",
  src: "/static/img/configuracao-inicial/icone-feito.png"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_generico_string = _resolveComponent("selecionar-generico-string")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_tipo_preco_modal = _resolveComponent("tipo-preco-modal")!
  const _component_tipo_custo_modal = _resolveComponent("tipo-custo-modal")!
  const _component_estoque_modal = _resolveComponent("estoque-modal")!
  const _component_tabela_preco_modal = _resolveComponent("tabela-preco-modal")!
  const _component_marca_modal = _resolveComponent("marca-modal")!
  const _component_categoria_produto_modal = _resolveComponent("categoria-produto-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.computedConfiguracao.etapaAtual === _ctx.EEtapaConfiguracaoInicial.Produtos)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            (_ctx.state.permissaoTipoCusto)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_selecionar_generico_string, {
                      placeholder: "Escolha seus tipos de custo",
                      itens: _ctx.state.optionsTipoCusto,
                      varios: true,
                      valoresSelecionados: _ctx.state.tiposCustoSelecionados,
                      "onUpdate:valoresSelecionados": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tiposCustoSelecionados) = $event))
                    }, null, 8, ["itens", "valoresSelecionados"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("a", {
                      class: "ss-botao-outros",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.abrirTipoCusto && _ctx.abrirTipoCusto(...args)))
                    }, _hoisted_11)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoTipoCusto)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoTipoPreco)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_selecionar_generico_string, {
                      placeholder: "Escolha seus tipos de preço",
                      itens: _ctx.state.optionsTipoPreco,
                      varios: true,
                      valoresSelecionados: _ctx.state.tiposPrecoSelecionados,
                      "onUpdate:valoresSelecionados": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.tiposPrecoSelecionados) = $event))
                    }, null, 8, ["itens", "valoresSelecionados"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("a", {
                      class: "ss-botao-outros",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.abrirTipoPreco && _ctx.abrirTipoPreco(...args)))
                    }, _hoisted_18)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoTipoPreco)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoUnidade)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_selecionar_generico_string, {
                      placeholder: "Escolha suas unidades",
                      itens: _ctx.state.optionsUnidade,
                      varios: true,
                      valoresSelecionados: _ctx.state.unidadesSelecionadas,
                      "onUpdate:valoresSelecionados": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.unidadesSelecionadas) = $event))
                    }, null, 8, ["itens", "valoresSelecionados"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoUnidade)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoEstoque)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_a_switch, {
                    class: "ss-switch",
                    checked: _ctx.computedConfiguracao.usarEstoquePadrao,
                    "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedConfiguracao.usarEstoquePadrao) = $event))
                  }, null, 8, ["checked"]),
                  (_ctx.computedConfiguracao.usarEstoquePadrao)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.abrirEstoque && _ctx.abrirEstoque(...args)))
                      }, _hoisted_29))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoTabelaPreco)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(_component_a_switch, {
                    class: "ss-switch",
                    checked: _ctx.computedConfiguracao.usarTabelaPrecoPadrao,
                    "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedConfiguracao.usarTabelaPrecoPadrao) = $event))
                  }, null, 8, ["checked"]),
                  (_ctx.computedConfiguracao.usarTabelaPrecoPadrao)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.abrirTabelaPreco && _ctx.abrirTabelaPreco(...args)))
                      }, _hoisted_35))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoMarca)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_component_a_switch, {
                    class: "ss-switch",
                    checked: _ctx.computedConfiguracao.usarMarcaPadrao,
                    "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedConfiguracao.usarMarcaPadrao) = $event))
                  }, null, 8, ["checked"]),
                  (_ctx.computedConfiguracao.usarMarcaPadrao)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.abrirMarca && _ctx.abrirMarca(...args)))
                      }, _hoisted_41))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.permissaoCategoria)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createVNode(_component_a_switch, {
                    class: "ss-switch",
                    checked: _ctx.computedConfiguracao.usarCategoriaProdutoPadrao,
                    "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedConfiguracao.usarCategoriaProdutoPadrao) = $event))
                  }, null, 8, ["checked"]),
                  (_ctx.computedConfiguracao.usarCategoriaProdutoPadrao)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.abrirCategoria && _ctx.abrirCategoria(...args)))
                      }, _hoisted_47))
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_50)),
      _createElementVNode("div", _hoisted_51, [
        (_ctx.computedConfiguracao.etapaAtual !== _ctx.EEtapaConfiguracaoInicial.Produtos)
          ? (_openBlock(), _createElementBlock("img", _hoisted_52))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "ss-botao-concluir",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.concluir && _ctx.concluir(...args)))
            }, [
              _createVNode(_component_a_spin, {
                spinning: _ctx.state.carregando
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Concluir!")
                ]),
                _: 1
              }, 8, ["spinning"])
            ]))
      ])
    ]),
    _createVNode(_component_tipo_preco_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirTipoPreco,
      "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.exibirTipoPreco) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_tipo_custo_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirTipoCusto,
      "onUpdate:visivel": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.exibirTipoCusto) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_estoque_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirEstoque,
      "onUpdate:visivel": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.exibirEstoque) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_tabela_preco_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirTabelaPreco,
      "onUpdate:visivel": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.exibirTabelaPreco) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_marca_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirMarca,
      "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.exibirMarca) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_categoria_produto_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirCategoria,
      "onUpdate:visivel": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.exibirCategoria) = $event))
    }, null, 8, ["operacao", "visivel"])
  ]))
}